import { isNilOrEmpty } from "utils";
const testAmount = (amt) =>
  Number.isNaN(parseInt(amt, 10)) ? `Error: Invalid amount ${amt}` : false;

const currencySettings = {
  SSD: {
    format: (amt, showSymbol) =>
      testAmount(amt) || `${showSymbol && "S$"}${parseInt(amt, 10).toLocaleString()}`,
  },
  LLD: {
    format: (amt, showSymbol) =>
      testAmount(amt) || `${showSymbol && "L$"}${parseInt(amt, 10).toLocaleString()}`,
  },
  USD: {
    format: (amt, showSymbol) =>
      testAmount(amt) ||
      `${showSymbol ? "USD " : ""}${(parseInt(amt, 10) / 100).toLocaleString(undefined, {
        minimumFractionDigits: 2,
      })}`,
  },
  UNKNOWN: {
    format: (amt, show, currency) => {
      if (isNilOrEmpty(amt)) return `Unknown Amount / Unknown Currency [${currency}]`;
      return `${show && (currency || "Unknown Currency")} ${(
        parseInt(amt, 10) / 100
      ).toLocaleString(undefined, {
        minimumFractionDigits: 2,
      })}`;
    },
  },
};

export const Money = ({ currency, amount, showSymbol = true }) => {
  const currencySetting = currencySettings[currency] || currencySettings.UNKNOWN;
  return currencySetting.format(amount, showSymbol, currency);
};
